type Predicate<T> = (value: T) => boolean;

export class Queue<T> {
  private messages: T[];

  constructor(private predicate: Predicate<T> = () => true) {
    this.messages = [];
  }

  setPredicate(predicate: Predicate<T>) {
    this.predicate = predicate;
  }

  resetPredicate() {
    this.predicate = () => true;
  }

  dequeueAll(): T[] {
    const dequeued = this.messages;
    this.messages = [];
    return dequeued;
  }

  get hasPending() {
    return this.messages.length > 0;
  }

  /**
   * Enqueue a value on the queue
   * @param t The value
   * @returns boolean was the value was enqueued
   */
  enqueue(t: T) {
    if (this.predicate(t)) {
      this.messages.push(t);
      return true;
    }

    return false;
  }
}
